import React, { useState } from 'react';
import axios from 'axios';
import './App.css';

function App() {
  const [longUrl, setLongUrl] = useState('');
  const [customCode, setCustomCode] = useState('');
  const [shortUrl, setShortUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setShortUrl('');

    try {
      const response = await axios.post('/api/url/shorten', { 
        longUrl,
        customCode: customCode.trim() || undefined
      });
      console.log('Response:', response.data);
      setShortUrl(response.data.shortUrl);
    } catch (err) {
      console.error('Error details:', err);
      setError(
        err.response?.data || 
        err.message || 
        'An error occurred while shortening the URL'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <div className="header-content">
          <h1>URL Shortener</h1>
        </div>
        <form onSubmit={handleSubmit} className="url-form">
          <input
            type="url"
            value={longUrl}
            onChange={(e) => setLongUrl(e.target.value)}
            placeholder="Enter your URL here (include http:// or https://)"
            required
            className="url-input"
          />
          <input
            type="text"
            value={customCode}
            onChange={(e) => setCustomCode(e.target.value)}
            placeholder="Custom code (optional) - e.g., 'my-link'"
            className="custom-code-input"
            pattern="[a-zA-Z0-9-_]+"
            title="Only letters, numbers, hyphens, and underscores are allowed"
          />
          <button type="submit" disabled={loading} className="submit-button">
            {loading ? 'Shortening...' : 'Shorten URL'}
          </button>
        </form>
        
        {error && (
          <div className="error">
            Error: {error}
          </div>
        )}
        
        {shortUrl && (
          <div className="result">
            <h3>Your shortened URL:</h3>
            <a href={shortUrl} target="_blank" rel="noopener noreferrer" className="short-url">
              {shortUrl}
            </a>
            <button
              onClick={() => navigator.clipboard.writeText(shortUrl)}
              className="copy-button"
            >
              Copy URL
            </button>
          </div>
        )}
      </header>
    </div>
  );
}

export default App; 